mutation UpdatePlatformCustomCovers($ids: [ID!]!, $input: UpdatePlatformCustomCoversInput!) {
  updatePlatformCustomCovers(ids: $ids, input: $input) {
    id
    publishAt
  }
}
